interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  loadingText?: string;
  variant?: "primary" | "secondary";
  fullWidth?: boolean;
}

const VARIANT_STYLES: Record<NonNullable<ButtonProps["variant"]>, string> = {
  primary: "bg-accent text-ink",
  secondary: "bg-white text-ink",
};

export function Button({
  loading,
  loadingText,
  variant = "primary",
  fullWidth = true,
  children,
  disabled,
  className = "",
  ...props
}: ButtonProps) {
  return (
    <button
      disabled={loading || disabled}
      className={`${fullWidth ? "w-full" : "w-auto"} rounded-xl border-2 border-ink py-3.5 text-[15px] font-extrabold shadow-[4px_4px_0_0_#1D1F1A] transition-[transform,box-shadow,opacity] duration-150 ease-out hover:-translate-x-px hover:-translate-y-px hover:shadow-[5px_5px_0_0_#1D1F1A] active:translate-x-[2px] active:translate-y-[2px] active:shadow-[2px_2px_0_0_#1D1F1A] active:duration-75 disabled:pointer-events-none disabled:opacity-50 ${VARIANT_STYLES[variant]} ${className}`}
      {...props}
    >
      {loading ? (loadingText ?? "Chargement...") : children}
    </button>
  );
}
